module.exports = __webpack_public_path__ + "img/sz001.28596c17.png";